import type { ButtonHTMLAttributes } from 'react';

/**
 * 設計系統按鈕（對應 docs/cms-screens 之 ButtonPrimary/Secondary/Danger/Ghost）。
 *
 * 樣式由 index.css 之 .btn / .btn--* 提供；此元件僅負責 variant → className。
 */
export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export function Button({ variant = 'secondary', className, ...rest }: ButtonProps): JSX.Element {
  return <button {...rest} className={`btn btn--${variant}${className ? ` ${className}` : ''}`} />;
}
